var _defineProperty = require("/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _PROJECT_TYPES$CODING, _PlayAnimations, _PROJECT_TYPES$CODING2, _LinePlot, _PROJECT_TYPES$CODING3, _RandomDots;

var _require = require('../constants'),
    BLOCK_LEVEL_TYPES = _require.BLOCK_LEVEL_TYPES,
    PROJECT_TYPES = _require.PROJECT_TYPES;

var ScratchComingSoonProject = 'ScratchComingSoonProject';
var ScratchMatrixDemoSimBeginnerProject = 'ScratchMatrixDemoSimBeginnerProject';
var ScratchMatrixPlayAnimationsBeginnerProject = 'ScratchMatrixPlayAnimationsBeginnerProject';
var ScratchMatrixPlayAnimationsCoreProject = 'ScratchMatrixPlayAnimationsCoreProject';
var ScratchMatrixPlayAnimationsAdvancedProject = 'ScratchMatrixPlayAnimationsAdvancedProject';
var ScratchMatrixSimLinePlotBeginnerProject = 'ScratchMatrixSimLinePlotBeginnerProject';
var ScratchMatrixSimDemoLinePlot = 'ScratchMatrixSimDemoLinePlot';
var ScratchMatrixSimLinePlotAdvancedProject = 'ScratchMatrixSimLinePlotAdvancedProject';
var ScratchMatrixSimLinePlotCoreProject = 'ScratchMatrixSimLinePlotCoreProject';
var ScratchMatrixSimDemoRandomDots = 'ScratchMatrixSimDemoRandomDots';
var ScratchMatrixSimChallengeBeginnerRandomDotsProject = 'ScratchMatrixSimChallengeBeginnerRandomDotsProject';
var ScratchMatrixSimChallengeCoreRandomDotsProject = 'ScratchMatrixSimChallengeCoreRandomDotsProject';
var ScratchMatrixSimChallengeAdvancedRandomDotsProject = 'ScratchMatrixSimChallengeAdvancedRandomDotsProject';
module.exports = {
  'Play Animations': (_PlayAnimations = {}, _defineProperty(_PlayAnimations, PROJECT_TYPES.DEMO, _defineProperty({}, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchMatrixDemoSimBeginnerProject,
      projectVideoId: 'dv6etKxr'
    }
  })), _defineProperty(_PlayAnimations, PROJECT_TYPES.CODINGPROJECT, (_PROJECT_TYPES$CODING = {}, _defineProperty(_PROJECT_TYPES$CODING, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchMatrixPlayAnimationsBeginnerProject,
      projectVideoId: 'dv6etKxr'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING, BLOCK_LEVEL_TYPES.CORE, {
    scratch: {
      scratchProject: ScratchMatrixPlayAnimationsCoreProject,
      projectVideoId: 'dv6etKxr'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING, BLOCK_LEVEL_TYPES.ADVANCED, {
    scratch: {
      scratchProject: ScratchMatrixPlayAnimationsAdvancedProject,
      projectVideoId: 'dv6etKxr'
    }
  }), _PROJECT_TYPES$CODING)), _PlayAnimations),
  'Line Plot': (_LinePlot = {}, _defineProperty(_LinePlot, PROJECT_TYPES.DEMO, _defineProperty({}, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchMatrixSimDemoLinePlot,
      projectVideoId: 'dv6etKxr'
    }
  })), _defineProperty(_LinePlot, PROJECT_TYPES.CODINGPROJECT, (_PROJECT_TYPES$CODING2 = {}, _defineProperty(_PROJECT_TYPES$CODING2, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchMatrixSimLinePlotBeginnerProject,
      projectVideoId: 'dv6etKxr'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING2, BLOCK_LEVEL_TYPES.CORE, {
    scratch: {
      scratchProject: ScratchMatrixSimLinePlotCoreProject,
      projectVideoId: 'dv6etKxr'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING2, BLOCK_LEVEL_TYPES.ADVANCED, {
    scratch: {
      scratchProject: ScratchMatrixSimLinePlotAdvancedProject,
      projectVideoId: 'dv6etKxr'
    }
  }), _PROJECT_TYPES$CODING2)), _LinePlot),
  'Random Dots': (_RandomDots = {}, _defineProperty(_RandomDots, PROJECT_TYPES.DEMO, _defineProperty({}, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchMatrixSimDemoRandomDots,
      projectVideoId: 'dv6etKxr'
    }
  })), _defineProperty(_RandomDots, PROJECT_TYPES.CODINGPROJECT, (_PROJECT_TYPES$CODING3 = {}, _defineProperty(_PROJECT_TYPES$CODING3, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchMatrixSimChallengeBeginnerRandomDotsProject,
      projectVideoId: 'dv6etKxr'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING3, BLOCK_LEVEL_TYPES.CORE, {
    scratch: {
      scratchProject: ScratchMatrixSimChallengeCoreRandomDotsProject,
      projectVideoId: 'dv6etKxr'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING3, BLOCK_LEVEL_TYPES.ADVANCED, {
    scratch: {
      scratchProject: ScratchMatrixSimChallengeAdvancedRandomDotsProject,
      projectVideoId: 'dv6etKxr'
    }
  }), _PROJECT_TYPES$CODING3)), _RandomDots)
};